import { put, takeLatest } from "redux-saga/effects";
import { types } from "../action_types";
import { GET } from "../../Utils/httpServices";
import CustomToster from "../../SharedComponents/CustomToaster";

const getToken = () => window.sessionStorage.getItem("token");

function* GetAuditLogsSaga({ payload }) {
  try {
    const { page = 1, limit = 20, adminId, action, targetType, startDate, endDate } = payload || {};
    let url = `admin/audit-logs?page=${page}&limit=${limit}`;
    if (adminId) url += `&adminId=${adminId}`;
    if (action) url += `&action=${action}`;
    if (targetType) url += `&targetType=${targetType}`;
    if (startDate) url += `&startDate=${startDate}`;
    if (endDate) url += `&endDate=${endDate}`;

    const response = yield GET(url, {
      headers: { Authorization: `Bearer ${getToken()}` },
    });

    if (response?.status === 200) {
      yield put({
        type: types.GetAuditLogsRequestSuccess,
        payload: response?.data?.data,
      });
    } else {
      yield put({ type: types.GetAuditLogsRequestFailure });
    }
  } catch (e) {
    CustomToster({
      type: "error",
      message: e?.response?.data?.message || e?.response?.data?.error?.message || e?.message,
    });
    yield put({ type: types.GetAuditLogsRequestFailure });
  }
}

function* GetAuditLogStatsSaga() {
  try {
    const response = yield GET(`admin/audit-logs/stats`, {
      headers: { Authorization: `Bearer ${getToken()}` },
    });

    if (response?.status === 200) {
      yield put({
        type: types.GetAuditLogStatsRequestSuccess,
        payload: response?.data?.data,
      });
    } else {
      yield put({ type: types.GetAuditLogStatsRequestFailure });
    }
  } catch (e) {
    yield put({ type: types.GetAuditLogStatsRequestFailure });
  }
}

export default function* AuditLogSaga() {
  yield takeLatest(types.GetAuditLogsRequest, GetAuditLogsSaga);
  yield takeLatest(types.GetAuditLogStatsRequest, GetAuditLogStatsSaga);
}
